<script>
  // constants
import parties from '../utils/parties';
import Photos from './Photos.svelte';

  import { intcomma } from 'journalize';
  import { formatPercent } from '../utils/format.js';

/** @type {string} */
  export let familyName
  /** @type {string} */
  export let givenName
  /** @type {string} */
  export let party
  /** @type {boolean} */
  export let isWinner
  /** @type {boolean} */
  export let isRunoff
  /** @type {number} */
  export let numOfwinners
  /** @type {boolean} */
  export let isIncumbent
  /** @type {number} */
  export let votes
  /** @type {number} */
  export let totalVotes
  /** @type {boolean} */
  export let isBallotMeasure
  /** @type {boolean} */
  export let hasParties
  /** @type {number | undefined} */
  export let numDecimalsInPercent
  /** @type {boolean} */
  export let face

  /** @type {import('../types.d').Crosswalk} */
  export let lookup;

  const name = `${givenName} ${familyName}`;
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }


  const partyFlag = isBallotMeasure ? familyName.toLowerCase() : party;
  const winnerText =
    familyName === 'Yes' ? 'Passed' : familyName === 'No' ? 'Failed' : 'winner';
</script>

{#if face}
<td class="candidate__cell">
  <div class="candidate__cell-headshot {slugify(name)} {party}">
  <Photos 
    name = {name}
    img = {lookup.img}
    avif = {lookup.avif}
    webp = {lookup.webp}
    party= {party}
    />
  </div>
</td>
{/if}
<th scope="row" 
class="candidate__cell candidate__cell-name"
class:candidate__cell-name-winner={isWinner | isRunoff}
>
  {#if givenName}{givenName}{/if}
  {familyName}
  {#if isIncumbent}
    <span
      class="candidate__cell-incumbent"
      title="Currently holds this office" role="img" aria-label="incumbent">i</span>
  {/if}
  {#if isWinner && numOfwinners==1}
  <span
  class="candidate__cell-runoff candidate__{partyFlag}">
  Winner
  </span>
  {:else if isWinner}
  <span
    class="candidate__cell-winner candidate__{partyFlag}">
    ✓
    </span>
  {:else if isRunoff}
  <span
    class="candidate__cell-runoff candidate__{partyFlag}">
    Runoff
    </span>
  {/if}
</th>
{#if !isBallotMeasure && hasParties}
  <td class="candidate__cell">
    <span class="mobile-only text-uppercase">{party}</span>
    <span class="desktop-only">{parties[party]? parties[party].label: party}</span>

  </td>
{/if}
<td
  class="candidate__cell candidate__cell-votes text-right"
  class:candidate__cell-ballot-measures={isBallotMeasure}>
  {intcomma(votes)}
</td>
<td
  class="candidate__cell candidate__cell-pct text-medium text-right"
  class:candidate__cell-ballot-measures={isBallotMeasure}>
  {formatPercent(votes, totalVotes, numDecimalsInPercent)}
  <span class="candidate__pct-symbol">%</span>
</td>

